import { LoginApi } from "./ApiConstant";
import { loggedIn, logout } from "../ReduxSlice/Auth/authSlice";
import { guardLogout } from "../ReduxSlice/Auth/guardSlice";

export function clearStaleEventSession(dispatch) {
  dispatch(logout());
  dispatch(guardLogout());
  localStorage.removeItem("userData");
  localStorage.removeItem("guardData");
}

/**
 * Exchange double-Base64 master_login.token (?token= / /Auth/:token)
 * for an Event JWT via POST users/login.
 */
export async function exchangeEventSsoToken(sendRequest, dispatch, ssoToken) {
  clearStaleEventSession(dispatch);

  const loginRes = await sendRequest(
    LoginApi,
    { data: { token: ssoToken }, method: "post" },
    false
  );

  if (loginRes?.status === 1 && loginRes?.data?.token) {
    dispatch(loggedIn(loginRes.data));
    localStorage.setItem("userData", JSON.stringify(loginRes.data));
    return { ok: true, data: loginRes.data };
  }

  return {
    ok: false,
    message: loginRes?.message || "Couldn’t complete sign-in. Please try again.",
  };
}
